import React from 'react';

interface IAppContext {
    widgetAlignment: string;
    clearTimers: () => void;
    isPurchase: boolean | undefined;
    togglePurchaseMode: () => void;
    toggleUserInteraction: () => void;
    openCommentsList: () => void;
}

// create a app context to store app level data 
export const AppContext = React.createContext<IAppContext>({
    widgetAlignment: 'leftbottom',
    clearTimers: () => {},
    isPurchase: false,
    togglePurchaseMode: () => {},
    toggleUserInteraction: () => {},
    openCommentsList: () => {},
});

export const useAppContext = () => React.useContext(AppContext);

export const AppContextProvider = AppContext.Provider;

export const AppContextConsumer = AppContext.Consumer;

